import React from 'react';
import { useParams } from 'react-router';

const BannerAbout = props => {
  const { language } = useParams();
  // console.log(props)
  return (
    <div className="group-banner">
      {props.banner?.img && props.banner?.img.includes('https://crm.flesta.vn//uploads/') ? (
        <img src={props.banner?.img} className="w-100 h-100" alt="" />
      ) : (
        <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${props.banner?.img}`} className="w-100 h-100" alt="" />
      )}
      <div className="group-company-overlay w-100 h-100"></div>
      <div className="container">
        <div className={`group-company-title jp-bold-700 ${language === 'en' ? 'text-capitalize' : ''}`}>
          {props.banner?.title}
        </div>
      </div>
    </div>
  );
};

export default BannerAbout;
